/* The app publishes these ranges to shop.metafields.production_timeline.json.
   The owner confirmed business days for production and existing transit ranges
   on October 3, 2026. Shipping estimates require a post-launch recheck.
   Keep production and transit separate; do not invent destination ranges. */
(function () {
  'use strict';
  var keys = {production: ['prodMin', 'prodMax'], pickup: ['prodMin', 'prodMax'], dhl: ['dhlExpressMin', 'dhlExpressMax'], israel: ['insideIsraelMin', 'insideIsraelMax']};
  var fallback = 'Please contact us for the current estimate.';
  function parse(value) {
    try { if (typeof value === 'string') value = JSON.parse(value); } catch (_) { return {}; }
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  }
  function days(value) {
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    if (!/^\d+$/.test(String(value))) return null;
    var number = Number(value);
    return Number.isSafeInteger(number) && number >= 0 && number <= 365 ? number : null;
  }
  function estimate(value, mode) {
    var data = parse(value), fields = keys[mode];
    if (!fields) return fallback;
    var min = days(data[fields[0]]), max = days(data[fields[1]]);
    if (min === null || max === null || max < min) return fallback;
    return (min === max ? String(min) : min + '–' + max) + (max === 1 ? ' business day' : ' business days');
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {estimate: estimate, parse: parse};
  if (typeof document === 'undefined') return;
  function render() {
    var source = document.querySelector('[data-hadaya-timeline-source]');
    var data = parse(source ? source.textContent : null);
    document.querySelectorAll('[data-hadaya-timing]').forEach(function (node) {
      node.textContent = estimate(data, node.getAttribute('data-hadaya-timing'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
  document.addEventListener('shopify:section:load', render);
  var content = document.getElementById('MainContent');
  if (content && typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (records) {
      var inserted = records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-hadaya-timing]') || node.querySelector('[data-hadaya-timing]'));
        });
      });
      if (inserted) render();
    }).observe(content, {childList: true, subtree: true});
  }
})();
